var React = require('react');

function Github (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.333 0c-4.42 0-8 3.673-8 8.203 0 3.625 2.292 6.7 5.47 7.783.4.077.547-.177.547-.395 0-.194-.007-.71-.01-1.394-2.225.495-2.695-1.1-2.695-1.1-.364-.947-.89-1.2-.89-1.2-.724-.509.056-.499.056-.499.804.058 1.226.845 1.226.845.713 1.255 1.872.892 2.33.682.072-.53.278-.892.506-1.097-1.776-.205-3.644-.91-3.644-4.053 0-.896.31-1.627.824-2.202-.09-.207-.36-1.04.07-2.17 0 0 .67-.22 2.2.84a7.491 7.491 0 012-.277c.68.004 1.36.095 2 .277 1.52-1.06 2.19-.84 2.19-.84.43 1.13.16 1.963.08 2.17.51.575.82 1.306.82 2.202 0 3.15-1.87 3.845-3.65 4.046.28.246.54.75.54 1.518 0 1.098-.01 1.98-.01 2.246 0 .216.14.472.55.39 3.2-1.076 5.49-4.152 5.49-7.772 0-4.53-3.582-8.203-8-8.203","fill":"#EFEFEF","fillRule":"nonzero"}));
}

Github.defaultProps = {"viewBox":"0 0 17 16"};

module.exports = Github;

Github.default = Github;
